import { Component, type ErrorInfo, type ReactNode } from 'react';

interface State {
  failed: boolean;
}

/** Last line of defence: a friendly message with a reload button instead of a blank page. */
export class ErrorBoundary extends Component<{ children: ReactNode }, State> {
  override state: State = { failed: false };

  static getDerivedStateFromError(): State {
    return { failed: true };
  }

  override componentDidCatch(error: Error, info: ErrorInfo) {
    console.error('The page crashed', error, info.componentStack);
  }

  override render() {
    if (!this.state.failed) return this.props.children;
    return (
      <main className="crash">
        <h1>Something went wrong.</h1>
        <p>Sorry about that. Reloading usually fixes it.</p>
        <button type="button" className="btn btn--primary" onClick={() => location.reload()}>
          Reload the page
        </button>
      </main>
    );
  }
}
